export default __webpack_public_path__ + "static/media/upload_2.f7a707bb.svg";